import { render, staticRenderFns } from "./SettingsLink.vue?vue&type=template&id=04f97ead&scoped=true"
import script from "./SettingsLink.vue?vue&type=script&lang=js"
export * from "./SettingsLink.vue?vue&type=script&lang=js"
import style0 from "./SettingsLink.vue?vue&type=style&index=0&id=04f97ead&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f97ead",
  null
  
)

export default component.exports